<template>
  <v-toolbar color="red darken-4" flat tile :dark="true">
    <div class="hidden-sm-and-down">
      <v-img :src="require('../assets/NSCC_logo.png')" height="60" width="100"></v-img>
    </div>
    <v-divider class="mx-4" inset vertical></v-divider>
    <v-toolbar-title>{{appTitle}}</v-toolbar-title>
    <v-spacer class="hidden-sm-and-down"></v-spacer>
    <div v-if="isAuthenticated">
      <v-btn outlined color="white" @click="logout">Logout</v-btn>
    </div>
  </v-toolbar>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'AppNavigation',
  data() {
    return {
      appTitle: 'Homework Portal',
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated"])
  },
  methods: {
    logout() {
      this.$store.dispatch('userSignOut');
    },
  }
};
</script>

<style scoped>
a {
  color: white;
  text-decoration: none;
}
</style>
